import React, { useState, useEffect } from "react";
import "../assets/css/OnStage.css";
import InstagramReelCard from "./InstagramReelCard";
import InstagramReelGrid from "./InstagramReelGrid";

import avatarImg from "../assets/img/on-stage/avatar.jpg";
import avatarImg2 from "../assets/img/on-stage/avatar2.jpg";

import reel1 from "../assets/img/on-stage/reel1.mp4";
import reel2 from "../assets/img/on-stage/reel2.mp4";
import reel3 from "../assets/img/on-stage/reel3.mp4";
import reel4 from "../assets/img/on-stage/reel4.mp4";
import poster1 from "../assets/img/on-stage/poster1.jpg";
import poster2 from "../assets/img/on-stage/poster2.jpg";
import poster3 from "../assets/img/on-stage/poster3.jpg";
import poster4 from "../assets/img/on-stage/poster4.jpg";


const isAndroid = () => /Android/i.test(navigator.userAgent || "");
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent || "");
const isMobileUA = () => isAndroid() || isIOS();

function extractIgShortcode(permalink) {
  try {
    const u = new URL(permalink);
    const parts = u.pathname.split("/").filter(Boolean);
    if (parts.length >= 2 && (parts[0] === "reel" || parts[0] === "p")) {
      return { type: parts[0], code: parts[1] };
    }
  } catch (_) { }
  return null;
}



function openInstagramDeep(permalink) {
  const parsed = extractIgShortcode(permalink);
  if (!parsed) {
    window.open(permalink, "_blank", "noopener,noreferrer");
    return;
  }

  const { type, code } = parsed;

  // iOS: esquema nativo directo
  if (isIOS()) {
    const deeplink = type === "reel" ? `instagram://reel/${code}` : `instagram://p/${code}`;
    const start = Date.now();
    window.location.href = deeplink; // gesture-driven
    setTimeout(() => {
      if (Date.now() - start < 1600) window.location.href = permalink;
    }, 1200);
    return;
  }

  // Android: intent:// con fallback a la URL web
  if (isAndroid()) {
    const intent = `intent://www.instagram.com/${type}/${code}/#Intent;scheme=https;package=com.instagram.android;S.browser_fallback_url=${encodeURIComponent(permalink)};end;`;
    window.location.href = intent;
    return;
  }

  // Desktop u otros: abrir web
  window.open(permalink, "_blank", "noopener,noreferrer");
}
function InstaEmbed({ permalink }) {
  // Render normal en desktop, overlay clickeable en mobile
  return (
    <div className="ig-wrapper">
      {/* Overlay SOLO en mobile para capturar el tap */}
      {isMobileUA() && (
        <button
          type="button"
          className="ig-deeplink-overlay"
          aria-label="Abrir en Instagram"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openInstagramDeep(permalink);
          }}
        />
      )}

      <blockquote
        className="instagram-media"
        data-instgrm-captioned
        data-instgrm-permalink={permalink}
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: 0,
          borderRadius: "6px",
          boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
          margin: "1px",
          padding: 0
        }}
      >
        <div style={{ padding: "16px" }}>
          <a
            href={permalink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#3897f0", textDecoration: "none" }}
          >
            Ver en Instagram
          </a>
        </div>
      </blockquote>
    </div>
  );
}


const OnStage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});
  console.log("isMobileUA:", isMobileUA());
  // Instagram embed script
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.instagram.com/embed.js";
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  const base = "../assets/img/on-stage/";
  const items = [
    {
      username: "franko.gustavo.argandona",
      displayName: "franko.gustavo.argandona",
      avatarUrl: avatarImg,
      profileUrl: "https://www.instagram.com/franko.gustavo.argandona/",
      media: { type: "video", src: reel1, poster: poster1, ratio: "4 / 5" },
      caption: "Bel momento del “mio” Disinganno. Aria: Crede l’uom dal “Trionfo del Tempo ...",
      timeLabel: "2 days ago",
      externalLink: "https://www.instagram.com/reel/DK9a3DbI9r3/?hl=it",
      location: "Asti, Italy"
    },
    {
      username: "lirica_tamagno and 4 others",
      displayName: "franko.gustavo.argandona",
      avatarUrl: avatarImg2,
      profileUrl: "https://www.instagram.com/lirica_tamagno/",
      media: { type: "video", src: reel2, poster: poster2, ratio: "4 / 5" },
      caption: "✨ IL TRIONFO DEL TEMPO E DEL DISINGANNO ✨ Un’oratorio che diventa ...",
      timeLabel: "5 days ago",
      externalLink: "https://www.instagram.com/p/DL5YsMbIfdH/?hl=it",
      location: "Asti, Italy"
    },
    {
      username: "lirica_tamagno and 2 others",
      displayName: "franko.gustavo.argandona",
      avatarUrl: avatarImg2,
      profileUrl: "https://www.instagram.com/lirica_tamagno/",
      media: { type: "video", src: reel3, poster: poster3, ratio: "4 / 5" },
      caption: "🎻Recenti memorie barocche con @les_arches_du_roi soprano ...",
      timeLabel: "1 week ago",
      externalLink: "https://www.instagram.com/reel/DBtQGIMgivo/?igsh=cnQ4ZzY2Y3lxcHhs",
      location: "Villa Della Regina, Turin"
    },
    {
      username: "lirica_tamagno and 3 others",
      displayName: "franko.gustavo.argandona",
      avatarUrl: avatarImg2,
      profileUrl: "https://www.instagram.com/lirica_tamagno/",
      media: { type: "video", src: reel4, poster: poster4, ratio: "16 / 9" },
      caption: "💥Un’ondata di musica ed emozione! Il 21 giugno, nella splendida Chiesa del ...",
      timeLabel: "2 weeks ago",
      externalLink: "https://www.instagram.com/p/DMYT0zQovsg/?hl=it",
      location: "Turin, Italy"
    },
  ];

  // Carga de imágenes (sin cambios)
  const loadImage = async (imagePath) => {
    const image = await import(`../assets/img/on-stage/${imagePath}`);
    return image.default;
  };
  useEffect(() => {
    const loadImages = async () => {
      const promises = imageList.map(async (image) => {
        const loadedImage = await import(`../assets/img/on-stage/${image.src}`);
        return { [image.src]: loadedImage.default };
      });
      const resolvedImages = await Promise.all(promises);
      setLoadedImages(Object.assign({}, ...resolvedImages));
    };
    loadImages();
  }, []);

  // Facebook SDK (sin cambios)
  useEffect(() => {
    if (!document.getElementById("facebook-jssdk")) {
      const fbRoot = document.createElement("div");
      fbRoot.id = "fb-root";
      document.body.appendChild(fbRoot);
      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.src =
        "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0";
      document.body.appendChild(script);
    }
  }, []);

  // Reprocesar embeds cuando el DOM cambie
  useEffect(() => {
    if (window.instgrm?.Embeds?.process) {
      window.instgrm.Embeds.process();
    }
    if (window.FB?.XFBML?.parse) {
      window.FB.XFBML.parse();
    }
  });

  const imageList = [
    { src: "Dido and Aeneas.jpg", credit: "", subtitle: "" },
    { src: "IMG_1531.jpg", credit: "", subtitle: "Gloria – Vivaldi – Teatro Chiabrera di Savona" },
    { src: "IMG_1533.jpg", credit: "", subtitle: "Gloria – Vivaldi – Teatro Chiabrera di Savona" },
    { src: "IMG_4928.JPG", credit: "", subtitle: "" },
    { src: "IMG_6134.JPG", credit: "", subtitle: "" },
    { src: "IMG_6135.JPG", credit: "", subtitle: "" },
    { src: "residenze-Orfeo-1024x1024.jpg", credit: "", subtitle: "" },
    { src: "IMG_8161.JPG", credit: "", subtitle: "Venere e Amore – Alessandro Scarlatti" },
    { src: "IMG_8164.JPG", credit: "", subtitle: "Venere e Amore – Alessandro Scarlatti" },
    { src: "IMG_8142.JPG", credit: "", subtitle: "Venere e Amore – Alessandro Scarlatti" },
    { src: "IMG_7945.JPG", credit: "", subtitle: "Venere e Amore – Alessandro Scarlatti" },
    { src: "IMG_7884.jpeg", credit: "", subtitle: "Venere e Amore – Alessandro Scarlatti" },
    { src: "IMG_8163.JPG", credit: "", subtitle: "Venere e Amore – Alessandro Scarlatti" },
    { src: "IMG_8002.JPG", credit: "", subtitle: "" },
    { src: "IMG_8003.JPG", credit: "", subtitle: "" },
    { src: "IMG_8004.JPG", credit: "", subtitle: "" },
    { src: "IMG_8013.JPG", credit: "", subtitle: "" },
    { src: "IMG_8014.JPG", credit: "", subtitle: "" },
    { src: "6dc402e5.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "9db0809e.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "059d349d.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "5903b1f7.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "86084945.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "CarminaBurana1.jpg", credit: "", subtitle: "Carmina Burana - Carl Orff " },
    { src: "CarminaBurana2.jpg", credit: "", subtitle: "Carmina Burana - Carl Orff" },
    { src: "CarminaBurana6.jpg", credit: "", subtitle: "Carmina Burana - Carl Orff" },
    { src: "CarminaBurana3.jpg", credit: "", subtitle: "Carmina Burana - Carl Orff (Teatro Verdi di Trieste)" },
    { src: "CarminaBurana4.jpg", credit: "", subtitle: "Carmina Burana - Carl Orff (Teatro Verdi di Trieste)" },
    { src: "CarminaBurana5.jpg", credit: "", subtitle: "Carmina Burana - Carl Orff (Teatro Verdi di Trieste)" },
    { src: "d764573d.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "dbe480be.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "e03ad039.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "Gloria.jpg", credit: "", subtitle: "Beatus vir / Gloria - A. Vivaldi" },
    { src: "Iltrionfo.jpg", credit: "", subtitle: "Il Trionfo del Tempo e del Disinganno - G.F Händel " },
    { src: "IMG_3251.JPG", credit: "" },
    { src: "IMG_5041.JPG", credit: "" },
    { src: "IMG_5042.JPG", credit: "" },
    { src: "IMG_8354.JPG", credit: "" },
    { src: "IMG_8920.JPG", credit: "" },
    { src: "IMG_8921.JPG", credit: "" },
    { src: "IMG_8923.JPG", credit: "" },
    { src: "IMG_8925.JPG", credit: "" },
    { src: "IMG_8926.JPG", credit: "" },
    { src: "IMG_8929.JPG", credit: "" },
    { src: "IMG_8930.JPG", credit: "" },
    { src: "IMG_8931.JPG", credit: "" },
    { src: "IMG_8934.JPG", credit: "" },
    { src: "IMG_9251.JPG", credit: "© Andrea Gelain Photography" },
    { src: "IMG_9252.JPG", credit: "© Andrea Gelain Photography" },
    { src: "IMG_9253.JPG", credit: "© Andrea Gelain Photography" },
    { src: "IMG_9270.JPG", credit: "© Andrea Gelain Photography" },
    { src: "IMG_9271.JPG", credit: "© Andrea Gelain Photography" },
    { src: "IMG_9272.JPG", credit: "© Andrea Gelain Photography" },
    { src: "IMG_9397.JPG", credit: "" },
    { src: "4C684DF9-E6BE-4E94-AFB9-04E6E24F3505.jpg", credit: "" },
    { src: "33FEE278-85ED-4C00-AF93-DA07B5436D7C.jpg", credit: "" },
    { src: "77c33f86-5ba8-47c3-829c-62e919ecc22d.jpg", credit: "" },
    { src: "DSC_1495.JPG", credit: "" },
    { src: "Foto en concierto segunda.jpg", credit: "© AstiLirica" },
    { src: "Foto en concierto.JPG", credit: "© AstiLirica" },
    { src: "Foto profesional cantando.JPG", credit: "" },
    { src: "Foto profesional segunda.jpg", credit: "" },
    { src: "Foto profesional.JPG", credit: "" },
  ];

  const handleImageClick = (image) => setSelectedImage(image);
  const closeImageViewer = () => setSelectedImage(null);

  const youtubeLinks = [
    {
      title: 'A Midsummer Night’s Dream - Britten - “Welcome wanderer... I know a bank”',
      url: "https://www.youtube.com/watch?v=iSujC8dGSEQ",
    },
    {
      title: 'Il Giustino - Vivaldi - “Vedrò con mio diletto”',
      url: "https://www.youtube.com/watch?v=zP2fvWEPVXs",
    },
    {
      title: 'Rinaldo - Händel - “Cara sposa”',
      url: "https://www.youtube.com/watch?v=Y1u9uG8TOLQ",
    },
    {
      title: 'Rodelinda - Händel - “Pompe vane di morte... Dove sei, amato bene?”',
      url: "https://www.youtube.com/watch?v=kdIT3h0-H5c",
    },
    {
      title: 'Carmina Burana - Carl Orff - “Olim lacus colueram”',
      url: "https://www.youtube.com/watch?v=ZvZ8ZfvTIno",
    },
    {
      title: 'Gloria - Vivaldi - “Domine Deus”',
      url: "https://www.youtube.com/watch?v=1p4dGvtkZ5w",
    },
    {
      title:
        "Franko Gustavo Argandoña - “Fammi combattere” Orlando - Händel. (Fabio Biondi)",
      url: "https://youtu.be/mMTOdpmiB6U?si=IkaoxobOhtugDw_D",
    },
    {
      title:
        "Monteverdi - “Oblivion soave” - L’incoronazione di Poppea | Franko Gustavo Argandoña",
      url: "https://youtu.be/QUI45mSps1Q?si=Et3cHwdw2L7EvAHx",
    }

  ];
  return (
    <div className="onstage-container">
      <h2 >On Stage</h2>

      {/* Video principal */}
      <div className="video-container">
        <video
          controls
          poster={require("../assets/img/on-stage/onstage.jpg")}
        >
          <source
            src={require("../assets/img/on-stage/onstage.mp4")}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="media-container">
        {/* Reels */}
        <div className="onstage-container" >
          <h3 className="py-2">Social Media</h3>
          <InstagramReelGrid items={items} />
        </div>
      </div>


      <div className="fb-video-wrapper">
        <div className="fb-video-responsive">
          <iframe
            title="Facebook Reel"
            src={
              "https://www.facebook.com/plugins/video.php" +
              "?href=" + encodeURIComponent("https://www.facebook.com/reel/1449257713165008") +
              "&show_text=false&width=560"
            }
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>


      {/* YouTube */}
      < section className="youtube-section" >
        <div className="youtube-links">
          <h3><i className="fab fa-youtube"></i> YouTube videos</h3>
          <ul>
            {youtubeLinks.map((link, i) => (
              <li key={i}>
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section >


      {/* Galería (sin cambios) */}
      < div className="gallery-container" >
        <h3 className="my-3">Gallery</h3>
        <div className="image-grid">
          {imageList.map((image) => (
            <div key={image.src} className="image-thumbnail-portrait">
              {loadedImages[image.src] ? (
                <img
                  src={loadedImages[image.src]}
                  alt={image.src}
                  className="thumbnail-img-portrait"
                  loading="lazy"
                  onClick={() => handleImageClick(image)}
                />
              ) : (
                <p>Cargando...</p>
              )}
              {image.subtitle && <div className="subtitle">{image.subtitle}</div>}
              {image.credit && <div className="watermark">{image.credit}</div>}
            </div>
          ))}
        </div>

        {
          selectedImage && (
            <div className="image-viewer">
              <span className="close-button" onClick={closeImageViewer}>
                &times;
              </span>
              <img
                src={require(`../assets/img/on-stage/${selectedImage.src}`)}
                alt="Selected"
                className="full-screen-image"
              />
              {selectedImage.subtitle && (
                <div className="subtitle-fullscreen">{selectedImage.subtitle}</div>
              )}
              {selectedImage.credit && (
                <div className="watermark-fullscreen">{selectedImage.credit}</div>
              )}
            </div>
          )
        }
      </div >
    </div >
  );
};

export default OnStage;